<microsec-form-builder
  #fb
  [shouldShowActionButtons]="true"
  [fields]="fields"
  submitButtonLabel="Next"
  submitButtonStyleClass="p-button-primary"
  (submitEvent)="submit($event)" />
